import { render, staticRenderFns } from "./sporeDevice.vue?vue&type=template&id=e63d3066&scoped=true"
import script from "./sporeDevice.vue?vue&type=script&lang=js"
export * from "./sporeDevice.vue?vue&type=script&lang=js"
import style0 from "./sporeDevice.vue?vue&type=style&index=0&id=e63d3066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63d3066",
  null
  
)

export default component.exports